import styled from "styled-components";

export const SSlides = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;
`;

export const SReader = styled.div`
  background: var(--primary-light);
  height: 100%;
  width: 100%;

  overflow: auto;

  .loader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    height: 100%;
    width: 100%;

    img {
      width: 35%;
      margin: auto;
      animation: logo-spin infinite 5s linear;

      @keyframes logo-spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }

    canvas {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

export const Controls = styled.div`
  position: relative;
  width: 100%;
  height: 2.5rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding-left: 1rem;
  padding-right: 1rem;

  background: var(--primary-dark);
  color: var(--text-primary-dark);
  border-radius: 0 0 1rem 1rem;

  overflow: auto;
  z-index: 1;

  i.disabled {
    cursor: not-allowed;
    color: lightgray;
  }

  i.clickable {
    cursor: pointer;
  }

  input {
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
    appearance: textfield;

    border-radius: 0.25rem;
    border: none;
    margin-right: 0.2rem;
    padding: 0 0.2rem;
  }

  .expand {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
